
import ModalWindow from '../modal-window';
import Button from '../../button';
import { StyleSizeType, StyleColorSchemeType } from '../../../styles/enums';
import { ButtonFillType } from '../../button/enums';
import { ModalSlotName } from '../enums';
import ModalCommonProps from '../mixins/ModalCommonProps';

const DEFAULT_BUTTON_TITLE = {
  CANCEL: 'Close',
  APPLY: 'Ok',
};

export default {
  name: 'ConfirmModal',
  components: {
    ModalWindow,
    Button,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      StyleColorSchemeType,
      StyleSizeType,
      ButtonFillType,
      ModalSlotName,
    };
  },
  computed: {
    cancelButtonTitle() {
      return this.modalData.cancelButtonTitle || DEFAULT_BUTTON_TITLE.CANCEL;
    },
    applyButtonTitle() {
      return this.modalData.applyButtonTitle || DEFAULT_BUTTON_TITLE.APPLY;
    },
  },
};
